import { Box } from "@mui/material";
import { MultiProviderResourcesAdditionalInfo } from "@/components/serviceFlow/appointments/createAppointment/selectTime";
import { AppointmentServiceInput } from "./multiProviderAppointmentDrawerContext";
import { useAppointmentAvailableResources } from "./useAppointmentAvailableResources";

export const ServiceResourcesInfo = ({
  appointmentServices,
}: {
  appointmentServices: AppointmentServiceInput[];
}) => {
  const resources = useAppointmentAvailableResources({ appointmentServices });

  const usesResources = resources?.services?.some(
    (service) => service.rooms?.isRoomRequired || service.devices?.length > 0
  );

  return (
    usesResources && (
      <Box
        sx={{
          mb: 2,
          backgroundColor: "background.default",
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
        }}
      >
        <MultiProviderResourcesAdditionalInfo resources={resources} />
      </Box>
    )
  );
};
